/**
 * Theme configuration for the SCAD system
 * This file defines all design tokens used throughout the application
 */

const theme = {
  colors: {
    // Primary brand colors
    primary: '#3F51B5', // Indigo
    primaryLight: '#E8EAF6',
    primaryDark: '#303F9F',
    
    // Secondary colors
    secondary: '#546E7A', // Blue Grey
    secondaryLight: '#CFD8DC',
    secondaryDark: '#37474F',
    
    // Accent color
    accent: '#FF4081', // Pink
    accentLight: '#FF80AB',
    accentDark: '#F50057',
    
    // Status colors
    success: '#4CAF50', // Green
    successLight: '#E8F5E9',
    successDark: '#388E3C',
    
    warning: '#FFC107', // Amber
    warningLight: '#FFF8E1',
    warningDark: '#FFA000',
    
    error: '#F44336', // Red
    errorLight: '#FFEBEE',
    errorDark: '#D32F2F',
      // UI colors
    background: '#F9FAFC',
    backgroundLight: '#F5F7FA',
    backgroundPattern: 'linear-gradient(135deg, #F9FAFC 25%, #F5F7FA 25%, #F5F7FA 50%, #F9FAFC 50%, #F9FAFC 75%, #F5F7FA 75%, #F5F7FA 100%)',
    backgroundSize: '40px 40px',
    surface: '#FFFFFF',
    surfaceHover: '#F5F7FA',
    divider: 'rgba(0, 0, 0, 0.08)',
    
    // Text colors
    textPrimary: '#263238',
    textSecondary: '#546E7A',
    textDisabled: '#90A4AE',
    textOnPrimary: '#FFFFFF',
    textOnDark: '#FFFFFF',
    
    // Card and container colors
    cardBackground: '#FFFFFF',
    cardShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
    cardBorder: '1px solid rgba(0, 0, 0, 0.04)',
    
    // Gradients
    gradientPrimary: 'linear-gradient(135deg, #3F51B5 0%, #5C6BC0 100%)',
    gradientSuccess: 'linear-gradient(135deg, #4CAF50 0%, #66BB6A 100%)',
    gradientWarning: 'linear-gradient(135deg, #FFC107 0%, #FFCA28 100%)',
    gradientError: 'linear-gradient(135deg, #F44336 0%, #EF5350 100%)',
  },
  
  typography: {
    fontFamily: "'Inter', 'Roboto', system-ui, sans-serif",
    
    // Font sizes
    fontSize: {
      xs: '0.75rem',    // 12px
      sm: '0.875rem',   // 14px
      md: '1rem',       // 16px
      lg: '1.25rem',    // 20px
      xl: '1.5rem',     // 24px
      xxl: '2rem',      // 32px
    },
    
    // Font weights
    fontWeight: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    
    // Line heights
    lineHeight: {
      tight: 1.2,
      normal: 1.5,
      loose: 1.8,
    },
    
    // Letter spacing
    letterSpacing: {
      tight: '-0.025em',
      normal: '0',
      wide: '0.025em',
      wider: '0.05em',
    },
  },
  
  spacing: {
    xs: '0.25rem',    // 4px
    sm: '0.5rem',     // 8px
    md: '1rem',       // 16px
    lg: '1.5rem',     // 24px
    xl: '2rem',       // 32px
    xxl: '3rem',      // 48px
  },
  
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    pill: '9999px',
  },
  
  shadows: {
    sm: '0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04)',
    md: '0 4px 6px rgba(0, 0, 0, 0.04), 0 1px 3px rgba(0, 0, 0, 0.02)',
    lg: '0 10px 25px rgba(0, 0, 0, 0.05), 0 5px 10px rgba(0, 0, 0, 0.02)',
    xl: '0 20px 40px rgba(0, 0, 0, 0.06)',
    card: '0 4px 20px rgba(0, 0, 0, 0.05)',
    hover: '0 8px 30px rgba(0, 0, 0, 0.08)',
  },
  
  transitions: {
    fast: '0.2s ease',
    normal: '0.3s ease',
    slow: '0.5s ease',
  },
  
  breakpoints: {
    xs: '0px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },
  
  zIndex: {
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modalBackdrop: 1040,
    modal: 1050,
    popover: 1060,
    tooltip: 1070,
  },
};

export default theme;
